exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".child-view[data-v-49c848f2]{position:relative}", ""]);

// exports
